module.exports = __webpack_public_path__ + "img/maxim.4c243791.jpg";